import { render, staticRenderFns } from "./CknoimgComponent.vue?vue&type=template&id=2b12f933&scoped=true"
import script from "./CknoimgComponent.vue?vue&type=script&lang=js"
export * from "./CknoimgComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b12f933",
  null
  
)

export default component.exports